import { render, staticRenderFns } from "./TwoPanelMultiselect.vue?vue&type=template&id=b56e4f1e&"
import script from "./TwoPanelMultiselect.vue?vue&type=script&lang=js&"
export * from "./TwoPanelMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports